// extracted by mini-css-extract-plugin
module.exports = {"disclaimerContainer":"cc_disclaimerContainer_1014780759"};